import React, { useContext } from 'react';
import { t } from '../../../../common/components/T';
import css from './Progress.module.scss';
import { LangContext } from '../../../../common/decorators/Language';

export default function Progress({ val }) {
    const { translation } = useContext(LangContext);
    const target = val.target;
    const value = val.value;
    const percent = (value / target) * 100;
    if (val?.component && React.isValidElement(val?.component)) return val?.component;
    return (
        <div className={css.wrapper}>
            <p className={css.label}>{`${value} ${t('of', 'из', 'all', translation)} ${target}`}</p>
            <div className={css.line}>
                <div
                    style={{
                        backgroundColor: percent < 100 ? 'var(--notSuccessColor)' : 'var(--successSuccess01)',
                        width: `${percent}%`
                    }}
                    className={css.lineIn}
                ></div>
            </div>
        </div>
    );
}
